// fetch('/browsing_context_suggestions.json')

window.Geo = {
  get: async () => {
    let response = await fetch("/browsing_context_suggestions.json");
    let data = await response.json();
    if (data.detected_values.country.handle !== "GB") {
      window.Geo.getCheckoutForms();

      window.Geo.hideBIN();
      window.Geo.hideCheckout();
      window.Geo.displayQf();
    }
    document.querySelector(".loader-container-cf").style.display = "none";
    const cartBlocks = document.querySelector(".cart__blocks");
    if (cartBlocks) {
      cartBlocks.style.display = "block";
    }
    return data;
  },
  hideBIN: () => {
    const paymentButton = document.querySelector(
      ".product-form__buttons [data-shopify='payment-button']"
    );
    if (paymentButton) {
      paymentButton.style.display = "none";
    }
  },
  hideCheckout: () => {
    const checkoutButton = document.querySelectorAll(".cart__footer .cart__ctas");
    if (checkoutButton.length) {
      checkoutButton.forEach(e=>{
         e.style.display = "none";
      })
    }
  },
  displayQf: () => {
    const quoteForm = document.querySelector("#quote-form");
    const totals = document.querySelector(".totals");
    const taxNote = document.querySelector(".tax-note");
    if (quoteForm) {
      quoteForm.style.display = "block";
      totals.style.justifyContent = "center";
      taxNote.style.textAlign = "center";
      document.querySelector(".cart__blocks").style.width = "100%";
    }
  },
  getCheckoutForms: () => {
    const forms = document.querySelectorAll('form[action="/cart"]');
    forms.forEach((form) => {
      form.onsubmit = (e) => {
        e.preventDefault();
        window.location.href = "/cart";
      };
    });
    console.log(forms);
  },
};

window.Geo.get();
console.log("Geo loaded");
